"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = void 0;
const dotenv_1 = __importDefault(require("dotenv"));
dotenv_1.default.config();
function getEnv(key, fallback) {
    const value = process.env[key];
    if (value !== undefined) {
        return value;
    }
    if (fallback !== undefined) {
        return fallback;
    }
    throw new Error(`Environment variable ${key} not found!`);
}
exports.getEnv = getEnv;
//# sourceMappingURL=getEnv.js.map